import logo from "../logoWhite.svg";

export default function Footer() {
    return (
        <footer className="bg-transparent w-full py-12">
        <div className="max-w-[80vw] mx-auto px-6">
        <div className="bg-[#201647] text-white rounded-xl p-8 flex flex-col md:flex-row justify-between items-center gap-6 rounded-9xl">
            {/* Left: Brand / Logo */}
            <div className="text-center md:text-left">
                <img src={logo} alt="RGU Motorsports Logo" className="w-24 h-auto mx-auto md:mx-0" />

    </div>

    {/* Right: Links */}
    <div className="flex flex-row gap-4 text-right">
    <a href="#" className="hover:text-gray-400 transition">
        About
        </a>
        <a href="#" className="hover:text-gray-400 transition">
        Services
        </a>
        <a href="#" className="hover:text-gray-400 transition">
        Contact
        </a>
        </div>
        </div>

    {/* Optional bottom text */}
    <p className="mt-6 text-center text-gray-500 text-sm">
          © 2026 RGU Motorsports. All rights reserved.
    </p>
    </div>
    </footer>
);
}
